/**
 * * Модель запроса
 */
export class DeleteInvalidFileRequestModel {
  /**
   * * Номер файла
   */
  FileId!: number;
  /**
   * * Следует указать чтобы гарантировать что никакой левый человек не сможет просто подставить fileId и удалить только что загружающиеся файлы
   */
  FolderId!: string;
  constructor(obj?: Partial<DeleteInvalidFileRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
